/**
 * Class CustomerLoginInput
 *
 * hide login related note or message when user starts to type in email or password input
 */
define(['jquery'], ($) => {
    class CustomerLoginInput {

        /**
         * Constructor
         *
         * @param {Object}  config  Configuration options passed in through JSON
         *
         * @returns {null}
         */
        constructor(config) {
            const defaultConfig = {
                emailInputSelector: '[data-js=customer-email-input]',
                passwordInputSelector: '[data-js=customer-password-input]',
                passwordNoteSelector: '[data-js=customer-password-note]',
                loginMessageSelector: '.messages'
            };
            // Merge default config options and provided config
            /** @type {Object} */
            this.config = { ...defaultConfig, ...config };

            this.attachListeners();
        }

        /**
         * Attach event listeners to customer login input elements
         *
         * @returns {null}
         */
        attachListeners() {
            $(document)
                .on('keyup', this.config.emailInputSelector, this.emailHandlerKeyup)
                .on('keyup', this.config.passwordInputSelector, this.passwordHandlerKeyup);
        }

        /**
         * Handle the event thrown when user lifts a keyboard key in email input
         *
         * @param {Event} e The event object
         *
         * @returns {null}
         */
        emailHandlerKeyup = (e) => {
            if (e.currentTarget.value) { // Check the value of email input
                this.toggleLoginMessage(false);
                // clear timeout callback used for hiding login validation message,
                // so if it is displayed again, it won't be hidden by previous
                // timeout callback, here we use global variable messageTimeout
                // so that we can access the callback via window
                clearTimeout(window.messageTimeout);
            }
        };

        /**
         * Handle the event thrown when user lifts a keyboard key in password input
         *
         * @param {Event} e The event object
         *
         * @returns {null}
         */
        passwordHandlerKeyup = (e) => {
            if (e.currentTarget.value) { // Check the value of login input
                this.togglePasswordNote(false);
                this.toggleLoginMessage(false);
                // clear timeout callback used for hiding password note or login
                // validation message, so any of them is displayed again, it won't
                // be hidden by previous timeout callback, here we use global variable
                // messageTimeout so that we can access the callback via window
                clearTimeout(window.messageTimeout);
            }
        };

        /**
         * Toggle the visibility of the password note elements
         *
         * @param {Boolean} show [Optional] Force visibility, or leave blank to toggle
         *
         * @returns {null}
         */
        togglePasswordNote(show) {
            $(this.config.passwordNoteSelector).toggle(show);
        }

        /**
         * Toggle the visibility of the login message elements,
         * usually they're login validation related ones
         *
         * @param {Boolean} show [Optional] Force visibility, or leave blank to toggle
         *
         * @returns {null}
         */
        toggleLoginMessage(show) {
            $(this.config.loginMessageSelector).toggle(show);
        }

    }

    return (config) => {
        return new CustomerLoginInput(config);
    };
});
